import MasonryVideo from '../components/MasonryVideo';

export default class DynamicMasonry {
  constructor(section) {
    this.el = section.el;
    this.masonryVideo = null;
    this.urls = this.el.querySelectorAll('[data-masonry-url]');
    this.videos = this.el.querySelectorAll('[data-masonry-video]');

    this._redirectMasonryFeatures = this._redirectMasonryFeatures.bind(this);
    this._masonryVideo = this._masonryVideo.bind(this);

    this._bindEvents();
  }

  _bindEvents() {
    this.urls.forEach(url => url.addEventListener('click', event => this._redirectMasonryFeatures(event)));
    this.videos.forEach(video => video.addEventListener('click', event => this._masonryVideo(event)));
  }

  onSectionUnload() {
    if (this.masonryVideo != null) {
      this.masonryVideo.remove();
    }
    this.urls.forEach(url => url.removeEventListener('click', event => this._redirectMasonryFeatures(event)));
    this.videos.forEach(video => video.removeEventListener('click', event => this._masonryVideo(event)));
  }

  _redirectMasonryFeatures(e) {
    const { currentTarget } = e;

    if (!this.el.contains(currentTarget)) return;

    const { masonryUrl } = currentTarget.dataset;

    if (masonryUrl !== '') {
      window.location = masonryUrl;
    }
  }

  _masonryVideo(event) {
    this.masonryVideo = new MasonryVideo(this.el, event);
  }
}
